// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoText_root__-mj6G"};